require('./_wks-define')('asyncIterator');


//////////////////
// WEBPACK FOOTER
// /Users/luca/dev/lucagarbin/mascioni.it/~/core-js/modules/es7.symbol.async-iterator.js
// module id = 313
// module chunks = 0